<script lang="ts">
    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";

    import WishlistPageItemSkeleton from "./WishlistPageItemSkeleton.svelte";
</script>

<div class="gw-wl-page-list-skeleton">
    <div class="gw-wl-page-list-skeleton-header">
        <BaseSkeleton width="25%" height="20px" />
    </div>
    <ul class="gw-wl-page-list__items">
        <li class="gw-wl-page-list__item">
            <WishlistPageItemSkeleton />
        </li>
        <li class="gw-wl-page-list__item">
            <WishlistPageItemSkeleton />
        </li>
        <li class="gw-wl-page-list__item">
            <WishlistPageItemSkeleton />
        </li>
        <li class="gw-wl-page-list__item">
            <WishlistPageItemSkeleton />
        </li>

        <li class="gw-wl-page-list__item">
            <WishlistPageItemSkeleton />
        </li>
        <li class="gw-wl-page-list__item">
            <WishlistPageItemSkeleton />
        </li>
    </ul>
</div>

<style lang="postcss">
    .gw-wl-page-list-skeleton {
        border-top: 2px solid var(--gw-grey-border-color);
    }

    .gw-wl-page-list-skeleton-header {
        width: 100%;
        padding: 0.5em 0;
    }

    .gw-wl-page-list__items {
        margin: 0;
        padding: 0;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
    }

    .gw-wl-page-list__item {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }
</style>
